import { render } from "./Procurement.vue?vue&type=template&id=7daa8d56"
import script from "./Procurement.vue?vue&type=script&lang=js"
export * from "./Procurement.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__